<template>
	<!-- <InfoButton @click="showOverlay" /> -->
	<div v-if="te('event')" class="container-fluid h-100 w-100">
		<BackButton :text="t('back_button.overview')" />
		<div class="event-container">
			<h1>{{ t(`event[${$route.params.id}].title`) }}</h1>
			<h2>{{ timeFrom }}</h2>
			<h3>{{ t(`event[${$route.params.id}].subtitle`) }}</h3>
			<p v-html="t(`event[${$route.params.id}].description`)"></p>
			<h4 class="bold">{{ t('event_text.event_running_from')}}</h4>
			<h4>{{ timeSpan }}</h4>
		</div>
		<div class="event-image" :style="eventImage"></div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useRoute } from 'vue-router';
import { Carousel, Modal } from "bootstrap";
import BackButton from "@/components/buttons/BackButton.vue";

export default {
	name: "Gallery",
	components: {
		BackButton,
	},
	setup() {
		const { t, te, tm } = useI18n();
		return { t, te, tm };
	},
	computed: {
		eventImage() {
			const { t, te, tm } = useI18n();
			const route = useRoute();  
			return `background-image: url('${t(`event[${route.params.id}].image`)}');`;
		},
		timeFrom() {
			const { t, te, tm } = useI18n();
			const route = useRoute();

			const dateFrom = new Date(t(`event[${route.params.id}].date_from`));
			const dateTill = new Date(t(`event[${route.params.id}].date_till`));

			return `${dateFrom.getDate()} ${this.getMonthName(dateFrom.getMonth())} ${dateFrom.getFullYear()}`;
		},
		timeSpan() {
			const { t, te, tm } = useI18n();
			const route = useRoute();

			const dateFrom = new Date(t(`event[${route.params.id}].date_from`));
			const dateTill = new Date(t(`event[${route.params.id}].date_till`));
			//3 oktober tot 17 oktober

			return `${dateFrom.getDate()} ${this.getMonthName(dateFrom.getMonth())} ${t('default_text.till')} ${dateTill.getDate()} ${this.getMonthName(dateTill.getMonth())}`;
		}
	},
	data() {
		return {
			Carousel: null,
		};
	},
	mounted() {
		const { tm } = useI18n();


	},
};
</script>

<style scoped>

	.event-image {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		width: 50%;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}

	.event-container {
		padding-top: 230px;
		padding-left: 170px;
		padding-right: 100px;
		width: 50%;
		color: #fff;
	}

	.event-container h1 {
		font-size: 48px;
		font-weight: bold;
	}

	.event-container h2 {
		margin-top: 20px;
		font-size: 36px;
		font-weight: bold;
	}

	.event-container h3 {
		font-size: 30px;
		font-weight: 500;
	}

	.event-container h4 {
		font-size: 25px;
		font-weight: 400;
	}

	.event-container h4.bold {
		font-weight: bold;
	}

	.event-container p {
		margin-top: 24px;
		margin-bottom: 60px;
		font-weight: 400;
		font-size: 20px;
	}
</style>